import { render, staticRenderFns } from "./mainPage.vue?vue&type=template&id=7f45d8b5&scoped=true&"
import script from "./mainPage.vue?vue&type=script&lang=js&"
export * from "./mainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f45d8b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\桌面\\学习资料\\ZXX\\ZJPMWEB\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f45d8b5')) {
      api.createRecord('7f45d8b5', component.options)
    } else {
      api.reload('7f45d8b5', component.options)
    }
    module.hot.accept("./mainPage.vue?vue&type=template&id=7f45d8b5&scoped=true&", function () {
      api.rerender('7f45d8b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/zxx/components/home-page/mainPage.vue"
export default component.exports